import React from "react";

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, info) {
		console.error("Unhandled UI error:", error, info?.componentStack);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						height: "100vh",
						textAlign: "center",
						padding: "2rem",
					}}
				>
					<h2>Something went wrong</h2>
					<p>
						Please reload the page. If this keeps happening, contact support.
					</p>
					<button
						onClick={() => window.location.reload()}
						style={{
							marginTop: "1rem",
							padding: "0.5rem 1.5rem",
							backgroundColor: "#1890ff",
							color: "#fff",
							border: "none",
							borderRadius: "4px",
							cursor: "pointer",
						}}
					>
						Reload
					</button>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
